import { render, staticRenderFns } from "./CharactersLimitCounter.vue?vue&type=template&id=4a757aaf&scoped=true&"
import script from "./CharactersLimitCounter.vue?vue&type=script&lang=ts&"
export * from "./CharactersLimitCounter.vue?vue&type=script&lang=ts&"
import style0 from "./CharactersLimitCounter.vue?vue&type=style&index=0&id=4a757aaf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a757aaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a757aaf')) {
      api.createRecord('4a757aaf', component.options)
    } else {
      api.reload('4a757aaf', component.options)
    }
    module.hot.accept("./CharactersLimitCounter.vue?vue&type=template&id=4a757aaf&scoped=true&", function () {
      api.rerender('4a757aaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CharactersLimitCounter.vue"
export default component.exports